var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-toolbar',{class:'headerPage'},[(_vm.showCiudadSelector)?_c('CiudadSelector',{attrs:{"form_dirty":_vm.form_dirty,"disabled":_vm.disabled},on:{"update":function($event){return _vm.update()}}}):_vm._e(),_c('q-space'),_c('q-toolbar-title',{staticClass:"h5 titleHeader title"},[_vm._v(_vm._s(_vm.Title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }